import { render, staticRenderFns } from "./ClientDataForm.vue?vue&type=template&id=1d25040c&"
import script from "./ClientDataForm.vue?vue&type=script&lang=js&"
export * from "./ClientDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDataForm.vue?vue&type=style&index=0&id=1d25040c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d25040c')) {
      api.createRecord('1d25040c', component.options)
    } else {
      api.reload('1d25040c', component.options)
    }
    module.hot.accept("./ClientDataForm.vue?vue&type=template&id=1d25040c&", function () {
      api.rerender('1d25040c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientForm/components/ClientDataForm.vue"
export default component.exports